/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import enUS from "./translations/en-US.json";
import zhCN from "./translations/zh-CN.json";
import deDE from "./translations/de.json";
import esES from "./translations/es.json";
import frFR from "./translations/fr.json";
import itIT from "./translations/it.json";
import jaJP from "./translations/ja.json";
import koKR from "./translations/ko.json";
import plPL from "./translations/pl.json";
import ptBZ from "./translations/pt.json";
import ruRU from "./translations/ru.json";
import trTR from "./translations/tr.json";
import zhTW from "./translations/zh-TW.json";

export default {
  "en-US": enUS,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  de: deDE,
  es: esES,
  fr: frFR,
  it: itIT,
  ja: jaJP,
  ko: koKR,
  pl: plPL,
  pt: ptBZ,
  ru: ruRU,
  tr: trTR,
};

export const languageMap = {
  "en-US": "English",
  "zh-CN": "中文 (简体)",
  "zh-TW": "中文 (繁體)",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  ja: "日本語",
  ko: "한국인",
  pl: "Polski",
  pt: "Português",
  ru: "Русский",
  tr: "Türkçe",
};
